/**
 *
 * @param {string} versionA 第一个版本号
 * @param {string} versionB 第二个版本号
 * @returns {number} 1: 版本A大于版本B; -1: 版本A小于版本B; 0: 版本号AB相等
 */
const compareVersion = (versionA: string, versionB: string): number => {
  if (typeof versionA !== 'string' || typeof versionB !== 'string') {
    throw new Error('versionA and versionB must be string in function compareVersion');
  }
  const compareTarget = versionA.split('.');
  const beComparedTarget = versionB.split('.');

  for (let i = 0; i < compareTarget.length && i < beComparedTarget.length; i++) {
    const currentCompareTarget = Number(compareTarget[i]);
    const currentBeComparedTarget = Number(beComparedTarget[i]);

    if (currentCompareTarget > currentBeComparedTarget) {
      return 1;
    } else if (currentCompareTarget < currentBeComparedTarget) {
      return -1;
    }
  }

  if (compareTarget.length > beComparedTarget.length) {
    return 1;
  } else if (compareTarget.length < beComparedTarget.length) {
    return -1;
  }

  return 0;
};

export default compareVersion;
